<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Saját cégek</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/data/own-companies/add')"
        icon="el-icon-plus"
        v-can="'data.owncompany.create'"
      >
        Új Saját cég
      </el-button>
    </div>
    <list />
    <template v-if="$route.meta.showAddOwnCompanyDialog">
      <own-company-dialog
        type="add"
      />
    </template>
    <template v-if="$route.meta.showUpdateOwnCompanyDialog">
      <own-company-dialog
        :ownCompanyId="$route.params.id"
        type="update"
      />
    </template>
  </el-card>
</template>

<script>
  import List from '../../components/data/ownCompanies/List';
  import OwnCompanyDialog from '../../components/data/ownCompanies/Dialog';

  export default {
    components: {
      List,
      OwnCompanyDialog,
    },
  };
</script>
